document.addEventListener("DOMContentLoaded", () => {
  const rows = document.querySelectorAll(".project-table__row");
  const previewImg = document.getElementById("collection-preview-img");

  if (!rows.length || !previewImg) return;

  const defaultRow = rows[0];
  const defaultImage = defaultRow.dataset.image;

  const setPreviewImage = (url) => {
    if (url) {
      previewImg.src = url;
      previewImg.classList.add("has-image");
    } else {
      previewImg.src = "";
      previewImg.classList.remove("has-image");
    }
  };

  defaultRow.classList.add("is-active");
  setPreviewImage(defaultImage);

  rows.forEach((row) => {
    row.addEventListener("mouseenter", () => {
      rows.forEach((r) => r.classList.remove("is-active"));
      row.classList.add("is-active");
      const imageUrl = row.dataset.image;
      setPreviewImage(imageUrl);
    });

    row.addEventListener("mouseleave", () => {
      rows.forEach((r) => r.classList.remove("is-active"));
      defaultRow.classList.add("is-active");
      setPreviewImage(defaultImage);
    });

    row.addEventListener("click", () => {
      const url = row.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
});
